import { compareZIndex, zIndexKey } from "../zIndex";

/** Sort scene objects by zIndex (numeric-aware), then array order. */
export function sortSceneObjects(objects: Record<string, unknown>[]): Record<string, unknown>[] {
  return objects
    .map((obj, index) => ({ obj, index }))
    .sort((a, b) => {
      const c = compareZIndex(zIndexKey(a.obj as { zIndex?: string }), zIndexKey(b.obj as { zIndex?: string }));
      if (c !== 0) return c;
      return a.index - b.index;
    })
    .map(({ obj }) => obj);
}
